import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxNavigationMenuItemsComponent} from './components/mx-navigation-menu-item/mx-navigation-menu-items.component';
import {MxNavigationMenuComponent} from './components/mx-navigation-menu/mx-navigation-menu.component';
import {MxSharedModule} from '../../shared/mx-shared.module';

@NgModule({
    imports: [
        CommonModule,
        MxMaterialModule,
        TranslateModule,
        MxSharedModule
    ],
  exports: [
    MxNavigationMenuComponent
  ],
  declarations: [MxNavigationMenuComponent, MxNavigationMenuItemsComponent]
})
export class MxNavigationMenuModule { }
